import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const UtilityApi = createApi({
  reducerPath: "utilityApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getSkillsByKeyApi: builder.query({
      query: (data) => {
        return {
          url: `/utility/skills/${data}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Utility" }
    }),
    getSkillById: builder.mutation({
      query: (data) => ({
        url: `/utility/skills/fromId`,
        method: "POST",
        body: data
      }),
      extraOptions: { service: "Utility" }
    }),
    postImageUploadAPI: builder.mutation({
      query: () => ({
        url: `/asset/asset/upload`,
        method: "POST"
      }),
      extraOptions: { service: "Utility" }
    })
  })
});

export const {
  useLazyGetSkillsByKeyApiQuery,
  useGetSkillByIdMutation,
  usePostImageUploadAPIMutation
} = UtilityApi;
